<template>
  <div id="send">
    <mt-header fixed :title="title">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>
    <div class="content">
      <mt-navbar v-if="category == '云端'" v-model="selected">
        <mt-tab-item :id="1">{{ $t("内部转账") }}</mt-tab-item>
        <mt-tab-item :id="2">{{ $t("外部转账") }}</mt-tab-item>
      </mt-navbar>
      <div v-if="selected === 1" class="address">
        <input
          type="text"
          :placeholder="$t('请输入收款用户ID')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="to_uid"
        />
      </div>
      <div v-else class="address">
        <input
          type="text"
          :placeholder="$t('请输入收款地址')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model.trim="address"
          @blur="doblue"
        />
        <img
          src="../../assets/img/coinDetail/ico_lianxiren_fasong.png"
          alt
          class="contact"
          style="width: 26px"
          @click="addressBook(category)"
        />
        <span class="warn" v-if="showWarn">{{ $t("地址格式不正确") }}</span>
      </div>
      <div class="address">
        <input
          type="text"
          :placeholder="display_coin_symbol"
          class="wx_one_ellipsis wx_fontSize3"
          style="width: 34%"
          v-model.trim="amount"
          @focus="dofocus"
        />
        <span class="fuhao">≈</span>
        <template v-if="category == '云端'">
          <!-- <span class="contact" v-if="detailCata.cloud_balance == 0"
            >0 USDT</span
          > -->
          <div v-if="category == '云端'">
            <span class="contact">
              <!-- <span class="computed" v-if="amount == 0">
                {{ $t("至少为10") }}
              </span> -->
              <span>
                {{ (detailCata.usd_price * amount) | numFilter }}
              </span>
              USDT
            </span>
          </div>
          <!-- <span
            class="warn2"
            v-if="
              detailCata.usd_price * amount > 0 &&
              detailCata.usd_price * amount < 10
            "
            >{{ $t("金额不足10") }}</span
          > -->

          <span class="contact" v-else-if="detailCata.balance == 0">0USDT</span>
        </template>
        <template v-else>
          <span class="contact" v-if="hdCoinInfo.balance == 0">0$</span>
          <span class="contact" v-else
            >{{ (hdCoinInfo.coinUnitPrice * amount) | numFilter }} USDT</span
          >
        </template>
      </div>

      <p class="tip">
        <span
          class="balance wx_fontSize2"
          v-if="this.$route.query.category == 'HD'"
          >{{ $t("当前余额") }} {{ hdCoinInfo.balance | numFilter | toThousandFilter }}
          {{ display_coin_symbol }}</span
        >
        <span class="balance wx_fontSize2" v-else
          >{{ $t("当前余额") }} {{ detailCata.cloud_balance | numFilter | toThousandFilter }}
          {{ display_coin_symbol }}</span
        >
        <span class="allSend wx_fontSize2" @click="allSend()">{{
          $t("全部发送")
        }}</span>
      </p>
      <p class="tip">
        <span class="balance wx_fontSize2" style="width: 100%">
          {{ $t('最小提币金额') }} {{ withdrawIntDetail.min_withdraw_value }}
        </span>
      </p>
      <div class="address">
        <input
          type="text"
          :placeholder="$t('备注(选填)')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="memo"
        />
      </div>
      <div v-if="memo_required == 1" class="address">
        <input
          type="text"
          :placeholder="$t('AddressTag')"
          class="wx_one_ellipsis wx_fontSize3"
          v-model="addressTag"
        />
      </div>
      <div v-if="withdrawIntDetail && selected === 2" class="fee">
        <div>{{ $t("交易费") }}</div>
        <div v-if="withdrawIntDetail.special_withdraw_config">
          {{ parseFloat(withdrawIntDetail.special_withdraw_config.fee) }}
          {{ withdrawIntDetail.special_withdraw_config.display_coin_symbol }}
        </div>
        <div v-else>
          {{ parseFloat(withdrawIntDetail.withdraw_fee) }}
          {{ this.$route.query.display_coin_symbol }}
        </div>
      </div>
      <!-- <input
        type="range"
        name="current"
        class="progress"
        :value="processPoint"
        :max="detailCata.max_fee"
        :min="detailCata.min_fee"
        :step="detailCata.min_fee / 10"
        id="processRange"
        @input="changeProcess()"
        :style="{
          background:
            '-webkit-linear-gradient(top, #1296db, #1296db) 0% 0% / ' +
            ((processPoint - detailCata.min_fee) /
              (detailCata.max_fee - detailCata.min_fee)) *
              100 +
            '% 100% no-repeat',
        }"
        v-if="category == '云端'"
      /> -->
      <!-- <input
        type="range"
        name="current"
        class="progress"
        :value="processPoint"
        :max="detailCata.maxGasPrice"
        :min="detailCata.minGasPrice"
        :step="detailCata.minGasPrice / 10"
        id="processRange"
        @input="changeProcess()"
        :style="{
          background:
            '-webkit-linear-gradient(top, #1296db, #1296db) 0% 0% / ' +
            (processPoint * 100) / detailCata.maxGasPrice +
            '% 100% no-repeat',
        }"
        v-else
      /> -->
      <!-- <div class="sub wx_fontSize3">
        {{ $t("慢") }}
        <input
          type="submit"
          :value="processPoint"
          style="
            height: 30px;
            line-height: 10px;
            color: #8c92a8;
            background: transparent;
            width: 84%;
          "
          class="submitVal"
        />{{ $t("快") }}
      </div> -->

      <div class="footer wx_fontSize3" @click="getSubmit">
        {{ $t("发送") }}
      </div>
    </div>

    <!-- 支付支付密码弹框 -->
    <div class="box" ref="box" v-show="show_pay_pwd">
      <div class="mag">
        <mt-cell :title="$t('请输入支付密码')">
          <span @click="close()">
            <img
              src="../../assets/img/ico_close_lan.png"
              alt=""
              style="width: 20px; height: 20px"
            />
          </span>
        </mt-cell>

        <div class="passContainer">
          <!-- 密码框 组件  输入完成给给父组件传递密码触发父组件值-->
          <Password ref="pay_pass" v-on:end="onEnd"></Password>
        </div>
      </div>
    </div>

    <!-- 发送验证码子组件 给子组件传递scenne参数 -->
    <VerifyPopup
      ref="refVerify"
      scene="credentials_withdraw"
      @onVerify="submitMsg"
    />
  </div>
</template>

<script>
import { httpCoinDetail, httpCoinFee, httpHDCoinSend } from "@/api/hdwallet";
import { httpAccountInfo, httpAccountInternalTransfer, httpAccountNetworkList, httpAccountTransfer } from "@/api/index";
import { httpGetUserInfo } from "@/api/login";
import Password from "@/components/Password";
import VerifyPopup from "@/components/VerifyPopup";
import { numFilter } from "@/filters/index";
import {
signBtcTransaction,
signEthTransaction,
signTokenTransaction,
} from "@/utils/hdwallet";
import { saoYiSaoMessage } from "@/utils/index";
import { validateEmpty } from "@/utils/validate";
import { Toast, MessageBox } from "mint-ui";
export default {
  components: { Toast, Password, VerifyPopup },
  data: function () {
    return {
      processPoint: 0,
      coin_symbol: "",
      display_coin_symbol: "",
      title: "",
      address: "",
      amount: 0,
      memo: "",
      price: "",
      detailCata: "",
      category: "",
      Prepare: {},
      result: "",
      currency_char: "",
      show_pay_pwd: false,
      password: "",
      pay: true,
      to_uid: "",
      selected: 1,
      hdCoinInfo: {},
      addressTag: "",
      withdrawIntDetail: {}, //手续费 校验规则
      memo_required: "",
      showWarn: false,
    };
  },
  created() {
    window.getvalueFromApp = this.getvalueFromApp;
  },
  computed: {
    ifPin: function () {
      return validateEmpty(this.$store.getters.pin) ? false : true;
    },
  },
  mounted() {},
  activated() {
    this.pay = true;
    this.coin_symbol = this.$route.query.coin_symbol;
    this.display_coin_symbol = this.$route.query.display_coin_symbol;
    // this.title = this.$t("发送") + " " + this.$route.query.display_coin_symbol;
    this.title = this.$t("发送") ;
    this.category = this.$route.query.category;
    this.price = this.$route.query.price;
    this.address = this.$route.query.addr || "";
    this.currency_char = this.$store.state.currency_char;
    this.network = this.$route.query.network;
    this.coin = this.$route.query.coin;
    this.memo_required = this.$route.query.memo_required;
    this.selected = 1;
    this.amount = 0;
    this.memo = "";
    this.to_uid = "";
    this.showWarn = false;
    this.httpAccountNetworkList();
    this.info();
    if (this.$route.query.result) {
      this.prepareSendHd();
    }
    this.getUserInfo();
    this.credentials = "";
  },
  methods: {
    dofocus() {
      if (this.amount <= 0) {
        this.amount = null;
      }
    },
    getUserInfo: function () {
      httpGetUserInfo()
        .then((res) => {
          this.$store.dispatch("setUserInfo", res.data);
        })
        .catch(() => {});
    },
    changeProcess: function () {
      var range = document.getElementById("processRange");
      console.log(range.value);
      this.processPoint = range.value;
    },
    addressBook(title) {
      if (this.category == "云端") {
        this.$router.push({
          path: "/addressBook",
          query: { title: "云端钱包地址簿" },
        });
      } else {
        this.$router.push({
          path: "/addressBook",
          query: { title: "HD钱包地址簿" },
        });
      }
    },
    Flicking() {
      saoYiSaoMessage();
    },
    getvalueFromApp(value) {
      Toast(value);
      this.address = value;
    },
    close() {
      this.show_pay_pwd = false;
    },

    // 接受子组件Password密码框传递的密码
    onEnd: function (val) {
      if (val.length == 6) {
        this.password = val;
        this.close();
        // 判断有无操作凭证
        if (this.credentials) {
          this.submitMsg(this.credentials);
        } else {
          // 开启短信验证组件
          this.$refs.refVerify.show = true;
        }
      }
    },

    // 短信验证子组件VerifyPopup传递的操作凭证
    submitMsg(credentials) {
      // credentials是一个对象

      var payload = {
        coin_symbol: this.coin_symbol,
        amount: this.amount,
        passWord_pay: this.password,
        network: this.network,
        coin: this.coin,
        addressTag: this.addressTag,
        memo: this.memo,
      };
      this.credentials = credentials;
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }

      // 内部转账
      if (this.selected === 1) {
        payload.to_uid = this.to_uid;
        httpAccountInternalTransfer(payload)
          .then((res) => {
            Toast(res.msg);
            if (res.code == 1) {
              this.show_pay_pwd = false;
              this.address = "";
              this.amount = 0;
              this.$router.back();
            }
          })
          .catch(() => {});
      } else {
        payload.to_address = this.address;
        // 提币发送接口

        httpAccountTransfer(payload)
          .then((res) => {
            Toast(res.msg);
            if (res.code == 1) {
              this.show_pay_pwd = false;
              this.address = "";
              this.amount = 0;
              this.$router.back();
            }
          })
          .catch(() => {});
      }
    },

    // 点击发送事件
    getSubmit: function () {
      if (this.category == "云端") {
        // 检查是否绑定了Google验证器
        if (this.$store.state.userInfo.is_google_check != 1) {
          MessageBox.alert(this.$t("提币前必须绑定google验证码"), this.$t("提示")).then(action => {
            this.$router.push("/googleValid");
          });
          return;
        }
        if (this.$store.state.userInfo.has_paypwd != 1) {
          Toast(this.$t("请先设置支付密码"));
          this.$router.push("/SetPayPassword");
          return;
        /* } else if (this.$store.state.userInfo.user_auth_status != 1) {
          Toast(this.$t("您还未进行实名认证,请先进行实名认证"));
          this.$router.push("/index/mypage");
          return; */
        }
        if ((!this.to_uid && this.selected == 1) || (!this.address && this.selected == 2) || this.showWarn || this.amount <= 0) {
          return false;
        }
        if (this.pay) {
          this.show_pay_pwd = true;
          this.$refs.pay_pass.focus();
          this.$refs.pay_pass.reset();
        } else {
          // 进行过一次验证后就不在需要第二次验证
          if (this.credentials) {
            this.submitMsg(this.credentials);
          } else {
            this.$refs.refVerify.show = true;
          }
        }
      } else {
        this.prepareSendHd();
        /* if (this.ifPin) {
          this.$router.push("/pincheck");
        } else {
          Toast("请先到个人中心设置pin码");
          return;
        } */
      }
    },

    // hd钱包发送逻辑
    prepareSendHd: function () {
      if (this.coin_symbol == "BTC") {
        //(input, to, value, fee)
        this.result = signBtcTransaction(
          this.detailCata.unspent || "",
          this.address,
          this.amount,
          this.processPoint
        );

        if (this.result) {
          this.send();
        }
      } else if (this.coin_symbol == "ETH") {
        this.result = signEthTransaction(
          this.detailCata.nonce || "",
          this.address,
          this.amount,
          this.detailCata.gas,
          this.processPoint
        );
        if (this.result) {
          this.send();
        }
      } else {
        this.result = signTokenTransaction(
          this.detailCata.nonce || "",
          this.detailCata.contract || "",
          this.address,
          this.amount,
          this.detailCata.gas,
          this.processPoint,
          this.detailCata.coin_decimal
        );
        if (this.result) {
          this.send();
        }
      }
    },
    send() {
      var p = {
        symbolId: this.symbolId,
        amount: this.amount,
        toAddress: this.address,
        data: this.result,
      };
      httpHDCoinSend(p)
        .then((res) => {
          Toast(res.msg);
          if (res.code == 1) {
            this.address = "";
            this.amount = 0;
          }
        })
        .catch(() => {});
    },

    // 全部发送余额
    allSend() {
      // if (this.category == "云端") {
      //   if (this.detailCata.cloud_balance == undefined) {
      //     return "";
      //   }
      //   var str = numFilter(
      //     this.detailCata.cloud_balance - this.detailCata.min_fee
      //   );
      //   if (str == undefined || str < 0 || isNaN(str)) {
      //     str = 0;
      //   }
      //   this.amount = str;
      // } else {
      //   if (this.detailCata.balance == undefined) {
      //     return "";
      //   }
      //   var str = numFilter(this.detailCata.balance - this.detailCata.min_fee);
      //   if (str == undefined || str < 0 || isNaN(str)) {
      //     str = 0;
      //   }
      //   this.amount = str;
      // }
      if (this.category == "云端") {
        if (this.detailCata.cloud_balance == undefined) {
          return false;
        } else if (this.detailCata.cloud_balance < 0) {
          this.amount = 0;
          return false;
        } else if (this.detailCata.cloud_balance > 0) {
          this.amount = this.detailCata.cloud_balance;
        }
      }
    },
    info() {
      if (this.$route.query.category == "云端") {
        httpAccountInfo({
          coin_symbol: this.coin_symbol,
          currency: this.$store.getters.currency,
        })
          .then((res) => {
            this.detailCata = res.data;
            this.processPoint = res.data.min_fee;
          })
          .catch(() => {});
      } else if (this.$route.query.category == "HD") {
        /* httpPrepare({ coin_symbol: this.coin_symbol })
          .then(res => {
            this.detailCata = res.data;
            this.processPoint = res.data.current;
          })
          .catch(() => {}); */
        httpCoinDetail({ symbolId: this.$route.query.symbolId }).then(
          ({ result }) => {
            this.hdCoinInfo = result;
          }
        );
        httpCoinFee({ symbolId: this.$route.query.symbolId }).then(
          ({ result }) => {
            const res = {};
            Object.keys(result).forEach((item) => {
              res[item] = result[item] * 10e-18;
            });
            this.detailCata = res;
            this.processPoint = res.gasPrice;
          }
        );
      }
    },

    // 获取提币网络的地址校验规则
    httpAccountNetworkList() {
      const netdata = { coin_symbol: this.$route.query.coin_symbol };
      const net = this.$route.query.network;
      httpAccountNetworkList(netdata)
        .then((res) => {
          const zhi = res.data.filter((item) => {
            return item.network == net;
          });
          this.withdrawIntDetail = zhi[0];
        })
        .catch();
    },
    // 控制input警告显示隐藏
    doblue() {
      const regex = new RegExp(this.withdrawIntDetail.address_regex);
      if (!regex.test(this.address)) {
        console.log(regex.test(this.address));
        this.showWarn = true;
      } else {
        this.showWarn = false;
      }
    },
  },
};
</script>

<style scoped>
.mint-header {
  background: #fff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.sao {
  width: 20px;
  height: 20px;
}
.content {
  padding: 0 15px;
  padding-top: 40px;
}
.address {
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #e3e8ed;
  width: 100%;
  color: #a9afc8;
  position: relative;
}
.address input {
  width: 90%;
  height: 75px;
  /*line-height: 75px;*/
}
.fuhao {
  height: 26px;
  position: absolute;
  left: 36%;
  bottom: 24px;
  line-height: 26px;
  color: #212529;
}
.contact {
  height: 26px;
  position: absolute;
  right: 0px;
  bottom: 24px;
  line-height: 26px;
  color: #212529;
}
.tip {
  width: 100%;
  position: relative;
  margin: 10px 0;
}
.balance {
  width: 80%;
  display: inline-block;
  text-align: right;
  color: #8c92a8;
}
.allSend {
  width: 20%;
  display: inline-block;
  text-align: center;
  color: #1296db;
}

.mark {
  color: #212529;
  margin-top: 30px;
}
.content .range {
  width: 100%;
}
.sub {
  color: #8c92a8;
  margin: 0 12px;
  width: 96%;
}

.progress {
  width: 94%;
  margin-left: 3%;
  height: 40px;
}

input[type="range"] {
  /*input外壳样式*/
  -webkit-appearance: none;
  border-radius: 10px;
  height: 5px;
  z-index: 10;
  margin-top: 20px;
  margin-bottom: 20px;
}

input[type="range"]::-webkit-slider-runnable-track {
  /*轨道*/

  height: 5px;

  background: rgba(225, 225, 225, 0.2);

  border-radius: 10px;
}

input[type="range"]::-webkit-slider-thumb {
  width: 15px;
  height: 15px;
  -webkit-appearance: none;
  margin-top: -5px;

  background: #1296db;

  border-radius: 50%;
}
.footer {
  width: 100%;
  height: 50px;
  background: #1296db;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-top: 40px;
  border-radius: 4px;
}
.box {
  position: absolute;
  top: 0px;

  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mag {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #fff;
  height: 60%;
}
.swiper {
  height: 80px;
}
.swiper img {
  width: 100%;
  max-height: 100%;
  border-radius: 10px;
}
.passContainer {
  margin-top: 30px;
}
.mint-navbar .mint-tab-item.is-selected {
  margin-bottom: 0;
}
.fee {
  display: flex;
  justify-content: space-between;

  align-items: center;
  margin-top: 30px;
}
.warn {
  position: relative;
  width: 100px;
  height: 20px;
  top: -50px;
  font-size: 12px;
  color: red;
  text-align: center;
}
.warn2 {
  position: absolute;
  top: 24px;
  right: 40px;
  font-size: 12px;
  color: red;

  height: 13px;
}

.computed {
  color: #d8e1e4;
  font-size: 16px;
  margin-right: 10px;
}
</style>
